import React, { useEffect, useState } from 'react';

interface Props {
  message: string;
  onUndo: () => void;
  onDismiss: () => void;
  durationMs?: number;
}

export const UndoToast: React.FC<Props> = ({ message, onUndo, onDismiss, durationMs = 8000 }) => {
  const [remaining, setRemaining] = useState(Math.ceil(durationMs / 1000));

  useEffect(() => {
    const timer = setTimeout(onDismiss, durationMs);
    const tick = setInterval(() => setRemaining(r => r - 1), 1000);
    return () => { clearTimeout(timer); clearInterval(tick); };
  }, [durationMs]);

  return (
    <div style={{
      position: 'fixed', bottom: 28, left: '50%', transform: 'translateX(-50%)',
      background: '#1A1F35', border: '1px solid #3A3F55', borderRadius: 12,
      padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 14,
      boxShadow: '0 8px 32px rgba(0,0,0,.6)', zIndex: 9999, whiteSpace: 'nowrap',
      animation: 'fadeSlideUp .25s ease',
    }}>
      <span style={{ fontSize: 13, color: '#D8DDEF' }}>{message}</span>
      <div style={{ width: 1, height: 20, background: '#3A3F55' }} />
      <button onClick={onUndo} style={{
        background: 'none', border: 'none', color: '#60A5FA',
        fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0,
      }}>↩ Desfazer ({remaining}s)</button>
      <button onClick={onDismiss} style={{
        background: 'none', border: 'none', color: '#3A3F55', fontSize: 16, cursor: 'pointer', padding: 0,
      }}>✕</button>
    </div>
  );
};
